<template>
  <div>
    <Line v-if="chartData" :data="chartData" :options="chartOptions" />
  </div>
</template>

<script setup lang="ts">
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import { computed } from 'vue'

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale)

const props = defineProps<{
  labels: string[],
  dataPoints: number[]
}>()

const chartData = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      label: 'Anxiety Level',
      data: props.dataPoints,
      fill: false,
      borderColor: '#f09943',
      tension: 0.3
    }
  ]
}))

const chartOptions = {
  responsive: true,
  animation: false,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      ticks: {
        color: '#a6917b'
      }
    },
    y: {
      min: 0,
      max: 10,
      ticks: {
        stepSize: 1,
        color: '#a6917b'
      }
    }
  }
}
</script>
